// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__bbSfa","addBtnContainer":"AddDetails_addBtnContainer__xk9LG"};